import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Chip ,Button, Typography } from '@material-ui/core';

import KPTable from '../../../../components/KPTComponents/KPTable';
import PopupMenu from '../../../../components/CustomComponents/PopupMenu';
import PreviewModal from '../../../../components/CustomComponents/PreviewModal';
import DuyetThanhTichModal from '../../../../components/CustomComponents/DuyetThanhTichModal';

import BangSachUpdate from '../BangSachUpdate';
import { monographActions } from '../../../../actions';
import { MONOGRAPHS_CONSTANTS } from '../../../../constants';
import { resolveQcvLabel } from '../../../../utils/qcvScoreOptions';

export default function BangSachTable(props) {
  const dispatch = useDispatch();
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );
  const loading = useSelector(state => state.monographReducer.loading);
  const totalMonographList = useSelector(state => state.monographReducer.totalMonographList);
  const personalMonographList = useSelector(state => state.monographReducer.personalMonographList);
  const { TYPE_OPTIONS: { INTERNATIONAL, DOMESTIC }} = MONOGRAPHS_CONSTANTS;

  const [values, setValues] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const [detail, setDetail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(false);

  const openDeleteMenu = (e, id) => {
    setDeleteId(id);
    setDeleteMenuAnchor(e.currentTarget);
  }
  const closeDeleteMenu = () => {
    setDeleteId(null);
    setDeleteMenuAnchor(null);
  }

  const handleDelete = () => {
    dispatch(monographActions.deleteMonograph(deleteId));
    closeDeleteMenu();
  }

  // const handleAccepted = (row) => {
  //   dispatch(monographActions.updateMonographAccepted({ id: row.id, accepted: !row.accepted }));
  // }

  const handleAccepted = (row = duyetThanhTich) => {
    dispatch(monographActions.updateMonographAccepted(
      [{
        id: row.formMonographId,
        accepted: !row.thanhTichAccepted,
        score: values?.score || 0,
        note: values?.note || '',
      }]
    ));
    setDuyetThanhTich(null);
    setValues(null);
  }

  const mobileMode = window.innerWidth <= 768;

  // const tableRows = props.filterType === 'person' ? personalMonographList : totalMonographList;

  var tableRows = [];
  if (props?.rows) {
    tableRows = props?.rows;
  } else {
    tableRows = props.filterType === 'person' ? personalMonographList : totalMonographList;
  }

  var columns = [
    { title: <b>STT</b>, dataIndex: 'id', width: '5%', render: (_, row, id) => id + 1 },
    {
      title: <b>Tiêu đề sách</b>,
      dataIndex: 'title',
      width: props.type === 'update' ? '25%' : '30%',
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Phân loại</b>,
      dataIndex: 'type',
      width: '20%',
      filters: [...INTERNATIONAL, ...DOMESTIC],
      onFilter: (value, row) => row.type === value,
      render: (value) => resolveQcvLabel(scoreInformationList, '5', [...INTERNATIONAL, ...DOMESTIC], value),
    },
    {
      title: <b>Vai trò</b>,
      dataIndex: 'role',
      width: '20%',
      filters: [
        { text: 'Tác giả chính', value: 'main' },
        { text: 'Đồng tác giả', value: 'member' }
      ],
      onFilter: (value, row) => row.role === value,
      render: (value) => value === 'main' ? 'Tác giả chính' : 'Đồng tác giả',
    },
    {
      title: <b>Tình trạng</b>,
      dataIndex: 'thanhTichAccepted',
      width: '15%',
      filters: [
        { text: 'Đã được duyệt', value: true },
        { text: 'Chưa được duyệt', value: false }
      ],
      onFilter: (value, row) => row.thanhTichAccepted === value,
      render: (value) => (
        <Chip
          size='small'
          variant='outlined'
          color={value ? 'primary' : 'default'}
          label={`${value ? 'Đã' : 'Chưa'} được duyệt`}
          style={{ width: '100%' }}
        />
      )
    },
    {
      title: <b>Tác vụ</b>,
      dataIndex: 'cc-actions',
      width: '15%',
      render: (_, row) => (
        <>
          <Typography variant='body2' color='primary' className='actions-button' onClick={() => setDetail(row)}>Chi tiết</Typography>
          {!(props.type === 'accept') && (
            <Typography
              variant='body2'
              color='secondary'
              className='actions-button'
              onClick={(e) => openDeleteMenu(e, row.id)}
            >
              Xoá
            </Typography>
          )}
          <Typography variant='body2' className='actions-button' onClick={() => setPreview(row?.link)}>Minh chứng</Typography>
          {(props.type === 'accept') && (
            <Typography
              variant='body2'
              color={row?.thanhTichAccepted ? 'secondary' : 'primary'}
              className='actions-button'
              onClick={() => {
                if (row?.thanhTichAccepted) handleAccepted(row); else setDuyetThanhTich(row);
              }}
            >
              {`${row?.thanhTichAccepted ? 'Huỷ xác' : 'Xác'} nhận đơn`}
            </Typography>
          )}
        </>
      ),
    },
  ];



  if (props.type === 'accept') {
    columns = [
      { ...columns[1], width: '35%', render: (value, row, id) => `${id + 1}. ${value}` },
      { ...columns[3], width: '20%' },
      { title: <b>Điểm</b>, dataIndex: 'score', width: '10%' },
      { ...columns[4], width: '20%' },
      { ...columns[5], width: '15%' },
    ];
  }

  if (props.type === 'update') {
    if (mobileMode) {
      columns = [
        {...columns[1], title: <b>Tiêu đề</b>, width: '45%'},
        {...columns[3], width: '30%'},
        {...columns[5], width: '25%'},
      ];
    } else {
      columns = [
        {...columns[0], width: '5%'},
        {...columns[1], width: '25%'},
        {...columns[2], width: '25%'},
        {...columns[3], width: '15%'},
        {...columns[4], width: '15%'},
        {...columns[5], width: '15%'},
      ];
    }
  }

  return (
    <Grid item xs={12}>
      <KPTable
        nonBorder={props.type === 'accept'}
        columns={columns}
        rows={tableRows}
        loading={loading}
      />

      <BangSachUpdate detail={detail} acceptMode={props.type === 'accept'} onClose={() => setDetail(null)} />

      <PopupMenu
        position='center'
        anchorEl={deleteMenuAnchor}
        handleClose={closeDeleteMenu}
        render={
          <div style={{ padding: 8 }}>
            <Typography style={{ paddingBottom: 16 }}>Xác nhận xoá sách chuyên khảo?</Typography>
            <Button variant='outlined' style={{ width: 'calc(50% - 4px)' }} onClick={closeDeleteMenu}>Huỷ</Button>
            <Button variant='contained' color='secondary' style={{ marginLeft: 8, width: 'calc(50% - 4px)' }} onClick={handleDelete}>Xác nhận</Button>
          </div>
        }
      />

      <PreviewModal
        open={!!preview}
        url={preview}
        handleClose={() => setPreview(null)}
      />

      <DuyetThanhTichModal
        type='formMonograph'
        info={duyetThanhTich}
        values={values}
        setValues={setValues}
        open={!!duyetThanhTich}
        handleClose={() => setDuyetThanhTich(null)}
        handleSubmit={handleAccepted}
      />
    </Grid>
  );
}